import React from 'react';
import { OrnamentCarousel } from './OrnamentCarousel';
export function GalleryStrip() {
  return <section className="w-full overflow-hidden bg-sage-900 py-12 sm:py-16" aria-label="Galería de esferas navideñas creadas con el manual" data-id="element-38" data-mp="2xentskyegxe8">
      <p className="mx-auto mb-7 max-w-md px-5 text-center font-serif text-[1.45rem] leading-snug text-cream sm:mb-9 sm:max-w-xl sm:px-8 sm:text-[1.9rem]" data-id="element-39" data-mp="2sgmaq00z4y2r">
        Cientos de ideas para inspirarte y crear{' '}
        <span className="italic text-gold-200" data-id="element-40" data-mp="3l3yxaa74x5w2">tu propia colección</span>
      </p>
      <div className="relative" data-id="element-41" data-mp="3g66xku090fhb">
        <OrnamentCarousel tone="dark" duration="55s" data-id="element-42" data-mp="3g3ukau5fqtal" />
        <div className="pointer-events-none absolute inset-y-0 left-0 w-10 bg-sage-900 sm:w-16" style={{
        maskImage: 'linear-gradient(to right, #000, transparent)',
        WebkitMaskImage: 'linear-gradient(to right, #000, transparent)'
      }} aria-hidden="true" data-id="element-43" data-mp="3b59fsij5hngc" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-10 bg-sage-900 sm:w-16" style={{
        maskImage: 'linear-gradient(to left, #000, transparent)',
        WebkitMaskImage: 'linear-gradient(to left, #000, transparent)'
      }} aria-hidden="true" data-id="element-44" data-mp="1vpao0htuc429" />
      </div>
    </section>;
}